import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from 'src/app/core/service/Auth/authService';
import { CookieService } from 'ngx-cookie-service';
import { MessageService } from 'primeng/api';
@Injectable({
  providedIn: 'root',
})
export class AuthHeaderInterceptor implements HttpInterceptor {
  omitCalls = ['auth'];
  skipInterceptor = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private messageService: MessageService,
    private cookieService: CookieService
  ) { }
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    this.omitCalls.forEach((api) => {
      if (request.url.includes(api)) {
        this.skipInterceptor = true;
      }
    });

    const accessToken = this.authService.getAuthToken();
    if (accessToken || this.skipInterceptor) {
      request = request.clone({
        headers: request.headers.set('x-access-token', '' + accessToken),
      });
    }

    // if (!request.headers.has('Content-Type')) {
    //   request = request.clone({
    //     headers: request.headers.set('Content-Type', 'application/json'),
    //   });
    // }

    // request = request.clone({
    //   headers: request.headers.set('Accept', 'application/json'),
    // });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
        }
        // this.messageService.clear();
        return event;
      }),
      catchError((error: HttpErrorResponse) => {
        if (error.status == 401) {
          localStorage.clear();
          this.messageService.clear();
          this.authService.userLogout();
          sessionStorage.clear();
          this.cookieService.deleteAll();
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.error.message,
          });
          setTimeout(() => {
            this.router.navigate(['/login']);
            return;
          }, 4000);
        } else if (error.error.message != 'No data found.' || error.status != 404) {
          if (error.error.message == 'No data found.') {
            this.messageService.clear();
          } else {
            this.messageService.clear();
            if (error.error.message) {
              this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.error.message,
              });
            }
          }
        }
        return throwError(error);
      })
    );
  }
  isTokenExpired() {
    // const expired = this.cookieService.check('accessToken');
    const expired =  sessionStorage.getItem('accessToken') !== null;
    if (expired == false) {
      this.router.navigate(['/login']);
    }
  }
}
